<ft-bar-chart *ngFor="let chart of data" [data]="chart"></ft-bar-chart>
